const Ryplazim = () => {
  return (
    <>
      <div className="mt-10 text-2xl font-bold">COPAY ASSISTANCE</div>

      <p className="my-2">
        If you need copay assistance for your patient please visit RYPLAZIM Co-Pay Assistance Portal For Providers by clicking the button below. Eligible patients can receive up to $20,000 over 12 months to cover the deductible, copay, and/or coinsurance for RYPLAZIM.
      </p>

      <div className="mt-10 font-bold">ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE
      </div>

      <ul className="my-2 list-disc ml-10">
        <li>Patients must be commercially insured.</li>
        <li>
          Patients must express a financial need.
        </li>
        <li>
          Assistance available for the treatment of congenital Plasminogen Deficiency / Plasminogen Deficiency Type 1.
        </li>
        <li>
          Patients' health plan permits members to participate in copay assistance programs
        </li>
      </ul>

      <div className="font-bold">RESTRICTIONS</div>

      <ul className="my-2 list-disc ml-10">
        <li>
          Not valid for prescriptions eligible for reimbursement by any federal or state healthcare programs, such as Medicare, Medicaid, Medigap, Veterans Affairs, Department of Defense, Tricare, or any other federal or state-funded programs.
        </li>
      </ul>
    </>
  )
}

export default Ryplazim